export const setWhiteLabelSettings = (value: any) => {
	return {
		type: 'SET_WHITE_LABEL_SETTINGS',
		payload: value,
	};
};
